"use client";

import { useAuth } from "../lib/hooks/useAuth";
import SignInWithGoogle from "../components/SignInWithGoogle";
import Dashboard from "../components/Dashboard";
import { preload } from 'next/navigation'
import { useCallback } from 'react'

export default function Home() {
  const { user, loading } = useAuth();

  const preloadMaps = useCallback(() => {
    preload('/maps')
  }, [])

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-8">
        <h1 className="text-4xl font-bold">Virtual Mapping App</h1>
        <p className="text-gray-600">Sign in to manage your property maps</p>
        <SignInWithGoogle />
      </div>
    );
  }

  return <Dashboard preloadMaps={preloadMaps} />;
}
